import { Link } from "react-router-dom";

import { PageHeader } from "@/components/PageHeader";
import { SEO } from "@/components/SEO";

export function AboutPage() {
  return (
    <>
      <SEO
        title="About Us"
        description="Established in 2008, Membertou Boxing Club is a community boxing club in Membertou, Nova Scotia. Coached by Greg and Daniel Martin. Where Warriors Train."
        path="/about"
      />

      <PageHeader
        eyebrow="About"
        title="Our Club"
        intro="A community boxing club in Membertou, Nova Scotia."
      />

      <section className="section section-white texture-light" aria-labelledby="club-heading">
        <div className="container-page max-w-3xl">
          <h2 id="club-heading" className="sr-only">
            About the club
          </h2>
          <p>
            Membertou Boxing Club is a community boxing club in Membertou, Nova
            Scotia. The club welcomes new and returning members who want to
            learn the sport of boxing, improve fitness, build confidence, and
            train in a respectful team environment.
          </p>
          <p className="mt-4">
            Whether someone comes to prepare for competition or to learn
            the art and sport of boxing, the club&apos;s open-door approach is
            rooted in hard work, encouragement, and respect.
          </p>
        </div>
      </section>

      <section
        className="relative overflow-hidden texture-light"
        style={{ backgroundColor: "#f5f5f5", color: "#0a0a0a" }}
        aria-labelledby="history-heading"
      >
        <div className="container-page relative z-10 py-16 sm:py-24">
          <div className="grid gap-12 lg:grid-cols-[1fr_1.2fr] items-start">
            <div>
              <span className="eyebrow">Our History</span>
              <h2 id="history-heading" className="mt-2">
                Established in 2008
              </h2>
              <div className="mt-8 flex items-center justify-center lg:justify-start">
                <img
                  src="/images/membertou-boxing-logo-black.svg"
                  alt=""
                  width={280}
                  height={280}
                  decoding="async"
                  className="block w-full max-w-[220px] sm:max-w-[260px] lg:max-w-[280px] h-auto"
                  style={{ opacity: 0.8 }}
                />
              </div>
            </div>
            <div className="space-y-5 text-lg leading-relaxed" style={{ color: "#0a0a0a" }}>
              <p>
                The Membertou Boxing Club was formally established in 2008 by
                coaches Greg and Daniel Martin, formerly of Glace Bay&apos;s
                Ring 73, and the Membertou Band Council. Housed at what
                residents simply referred to as &ldquo;the gym&rdquo; for
                generations, the club created its own following and began to
                attract eager students of all ages.
              </p>
              <p>
                Over time, many new faces walked through its doors. Many of those students are still
                training at the club today and encouraging new members to take
                interest. Coaches Greg and Daniel Martin have since become
                honourary members of Membertou&apos;s community. They have
                helped shape champions and make dramatically positive impacts in
                the lives of their students.
              </p>
              <p>
                In 2015, the club adopted the Mi&apos;kmaw phrase{" "}
                <em lang="mic">
                  Ta&apos;n Wen&apos;ju&apos;te&apos;kewinu&apos;k
                  Etl-kina&apos;masulti&apos;tij
                </em>{" "}
                as the name of its training area. Translated, it means{" "}
                <strong>Where Warriors Train</strong>.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section
        className="relative overflow-hidden"
        style={{ backgroundColor: "#d71920", color: "#fff" }}
      >
        <div className="container-page relative z-10 py-16 sm:py-20 text-center flex flex-col items-center gap-5">
          <h2 className="max-w-[20ch]">Interested in joining?</h2>
          <p className="text-lg max-w-prose" style={{ color: "rgba(255,255,255,0.9)" }}>
            Visit the Join Our Club page or contact us.
          </p>
          <div className="mt-2 flex flex-col sm:flex-row w-full sm:w-auto justify-center gap-3 sm:gap-4">
            <Link to="/join" className="btn-on-red w-full sm:w-auto">
              Join Our Club
            </Link>
            <Link to="/contact" className="btn-on-red-outline w-full sm:w-auto">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
